(function () {

    angular
    .module('meanApp')
    .controller('subscribeCtrl', subscribeCtrl);

    subscribeCtrl.$inject = [
        'alert', 
        '$rootScope',
        '$scope', 
        '$location', 
        'authentication', 
        'isLogin', 
        'loginModal', 
        'usersManager',
        'currentUser'];
    function subscribeCtrl(
        alert, 
        $rootScope, 
        $scope, 
        $location, 
        authentication, 
        isLogin, 
        loginModal, 
        usersManager,
        currentUser) {
    
    var vm = this;
    vm.locationPathSaved = $location.path();
    //$location.path('/');
    var successFunction = function (result) {
        var userDataFromBackEnd = result.user;
        angular.extend(this.currentUser, userDataFromBackEnd);
        currentUser.set(this.currentUser);

        console.log(result);
        var modal = loginModal.get();
        if (modal) {
            modal.close();
        }
        //this will trigger new controller and retrieve the currentuser ?
        $location.path(vm.locationPathSaved);
        alert.push('success', 'Bienvenue sur fraiseoubacon.com');
    }.bind(this);

    //init values
    vm.credentials = {
      email : '',
      password : ''
    };

    vm.submitLoading = false;
    vm.isLogin = isLogin;
    vm.fbLoading = false;//display the facebook button in loading state
    vm.showPassword = false;
    vm.noEmailError = false;

    vm.sendNewPassword = function () {
      //todo un email doit etre spécifié
        if (!vm.email) {
            vm.noEmailError = true;
        }
        else {
            vm.credentials = {
                email : vm.email
            };
            var user = usersManager.set(vm.credentials);
            user.resetPassword(vm.credentials)
            .error(function(err) {
                var modal = loginModal.get();
                if (modal) {
                    modal.close();
                }
                alert.push('danger', 'Une erreur est survenue, merci de réessayer ultérieurement.');
            })
            .success(function(result) {
                var modal = loginModal.get();
                if (modal) {
                    modal.close();
                }
                alert.push('success', 'Votre mot de passe a été réinitialisé, veuillez consulter votre boite mail.');
            });
        }  
    };

    vm.onEyeClicked = function() {
      vm.showPassword = !vm.showPassword;
    };

    //TODO differentiate register and login because user can make a mistake by signing in on registering
    vm.onSubmit = function () {
        vm.showPassword = false;//for better security
        vm.emailError = false; //remove the errors
        vm.submitLoading = false;
        
        if (vm.email && vm.password) {
            vm.credentials = {
                email : vm.email,
                password : vm.password
            };

        if (!vm.isLogin) {
            this.currentUser = usersManager.set(vm.credentials);
          
            this.currentUser.register().then(successFunction, function(err) {
                if (err && err.code === 11000) {
                    vm.emailError = true;
                    vm.password = '';
                }
            });
        }
        else {//here is the login process
          //distinguish two use cases auth is successful, wrong because email does not exist, wrong because password is false
            vm.passwordError = false;
            this.currentUser = usersManager.set(vm.credentials);
            if (this.currentUser) {
                console.log('currentuser initiated');
                this.currentUser.login().then(successFunction, function(err) {
                    vm.passwordError = true;
                    //alert.push('danger', 'Votre email et/ou votre mot de passe sont erronés');
                });
            }
            else {
                console.log('there is no currnet user :o');
            }
        }
    }
      
    };   
      

  }

})();